(() => {
  if (window.KoshirenCollection) return;
  window.KoshirenCollection = true;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');
  const controllers = new Map();
  const maxQuantity = 99;
  const validQuantity = value => Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= maxQuantity;
  const money = (value,currency)=>{const locale=document.documentElement.lang||'en';const code=currency||'USD';const amount=new Intl.NumberFormat('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}).format(Number(value)/100);if(code==='USD')return locale.startsWith('zh')?amount+' 美元':'USD $'+amount;return new Intl.NumberFormat(locale,{style:'currency',currencyDisplay:'code',currency:code}).format(Number(value)/100);};
  const parseMessages = section => {
    try { return JSON.parse(section.querySelector('[data-kr-messages]')?.textContent || '{}'); }
    catch { return {}; }
  };
  function setupOrder(section, signal) {
    const form = section.querySelector('[data-kr-order]');
    if (!form) return;
    const product = form.querySelector('[data-kr-product]');
    const mode = form.querySelector('[data-kr-mode]');
    const quantity = form.elements.quantity;
    const submit = form.querySelector('[data-kr-submit]');
    const messages = parseMessages(section);
    const allOptions = [...product.options].map(option => option.cloneNode(true));
    const unavailable = form.querySelector('[data-kr-unavailable]');
    const error = form.querySelector('[data-kr-error]');
    const recover = form.querySelector('[data-kr-recover]');
    const update = () => {
      const selected = product.selectedOptions[0];
      const available = Boolean(selected && selected.dataset.available === 'true' && selected.value);
      unavailable.hidden = available;
      product.disabled = product.options.length === 0;
      submit.disabled = !available || !validQuantity(quantity.value) || Boolean(window.KoshirenCart?.busy) || Boolean(form.dataset.krUncertain);
      const addButton = form.querySelector('[data-kr-add-order]');
      if(addButton) addButton.disabled = submit.disabled;
      form.querySelector('[data-kr-total]').textContent = selected?.value && validQuantity(quantity.value) ? money(Number(selected.dataset.price) * Number(quantity.value), form.dataset.currency) : '—';
      form.querySelector('[data-kr-quantity="-1"]').disabled = !validQuantity(quantity.value) || Number(quantity.value) <= 1;
      form.querySelector('[data-kr-quantity="1"]').disabled = !validQuantity(quantity.value) || Number(quantity.value) >= maxQuantity;
    };
    const filter = key => {
      product.replaceChildren(...allOptions.filter(option => option.dataset.mode === mode.value).map(option => option.cloneNode(true)));
      const options = [...product.options];
      const chosen = key ? options.find(option => option.dataset.key === key) : options.find(option => option.dataset.available === 'true') || options[0];
      if (chosen) product.value = chosen.value;
      else product.selectedIndex = -1;
      error.hidden = true;
      update();
    };
    mode.addEventListener('change', () => filter(), { signal });
    product.addEventListener('change', update, { signal });
    quantity.addEventListener('input', update, { signal });
    form.addEventListener('click', event => {
      const button = event.target.closest('[data-kr-quantity]');
      if (!button || window.KoshirenCart?.busy) return;
      quantity.value = String(Math.max(1, Math.min(maxQuantity, (Number(quantity.value) || 1) + Number(button.dataset.krQuantity))));
      update();
    }, { signal });
    document.addEventListener('kr:select-coin', event => {
      mode.value = 'single';
      filter(event.detail.key);
      product.focus({ preventScroll: true });
    }, { signal });
    form.addEventListener('submit', event => {
      event.preventDefault();
      window.KoshirenCart?.add(form, 'checkout');
    }, { signal });
    form.addEventListener('kr:cart-state', update, { signal });
    filter();
  }
  function setupSection(section) {
    if (controllers.has(section)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const cleanups = [];
    controllers.set(section, () => { controller.abort(); cleanups.forEach(cleanup => cleanup()); });
    const animated = section.dataset.animate !== 'false' && !reduced.matches;
    if (animated && 'IntersectionObserver' in window && !window.Shopify?.designMode) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('kr-visible'); observer.unobserve(entry.target); }
      }), { threshold: .08 });
      section.querySelectorAll('[data-kr-reveal]').forEach(element => { element.classList.add('kr-reveal-ready'); observer.observe(element); });
      cleanups.push(() => observer.disconnect());
      const pause = new IntersectionObserver(([entry]) => section.classList.toggle('kr-paused', !entry.isIntersecting));
      pause.observe(section); cleanups.push(() => pause.disconnect());
    }
    if (animated && finePointer.matches) {
      section.querySelectorAll('.kr-box-image[data-kr-tilt],.kr-gallery-box[data-kr-tilt]').forEach(element => {
        let frame;
        let bounds;
        element.addEventListener('pointerenter', () => { bounds = element.getBoundingClientRect(); }, { signal });
        element.addEventListener('pointermove', event => {
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(() => {
            if (!bounds) return;
            const x = (event.clientX - bounds.left) / bounds.width - .5;
            const y = (event.clientY - bounds.top) / bounds.height - .5;
            element.style.transform = `translate3d(${x * 3}px,${y * 3}px,0)`;
          });
        }, { signal });
        element.addEventListener('pointerleave', () => { cancelAnimationFrame(frame); element.style.transform = ''; bounds = null; }, { signal });
        cleanups.push(() => cancelAnimationFrame(frame));
      });
    }
    setupOrder(section, signal);
  }
  function setupHeader(header) {
    if (controllers.has(header)) return;
    const controller = new AbortController();
    const { signal } = controller;
    const search = header.querySelector('[data-kr-search]');
    header.querySelector('[data-kr-search-open]')?.addEventListener('click', () => search.showModal(), { signal });
    header.querySelector('[data-kr-search-close]')?.addEventListener('click', () => search.close(), { signal });
    const language = header.querySelector('[data-kr-language]');
    document.addEventListener('click', event => { if (language && !language.contains(event.target)) language.open = false; }, { signal });
    header.addEventListener('keydown', event => { if (event.key === 'Escape' && language?.open) { language.open = false; language.querySelector('summary').focus(); } }, { signal });
    const resize = new ResizeObserver(() => document.documentElement.style.setProperty('--kr-nav-height', `${header.offsetHeight}px`));
    resize.observe(header);
    controllers.set(header, () => { controller.abort(); resize.disconnect(); search?.close(); });
  }
  function boot(root = document) {
    root.querySelectorAll('[data-kr-section]').forEach(setupSection);
    root.querySelectorAll('[data-kr-header]').forEach(setupHeader);
  }
  document.documentElement.classList.add('kr-js');
  document.addEventListener('click', event => {
    const coin = event.target.closest('[data-kr-select-coin]');
    const link = event.target.closest('a[href^="#"]');
    const anchor = coin ? '#order-selection' : link?.getAttribute('href');
    if (!anchor || anchor === '#') return;
    const target = document.getElementById(anchor.slice(1));
    if (!target) return;
    event.preventDefault();
    if (coin) document.dispatchEvent(new CustomEvent('kr:select-coin', { detail: { key: coin.dataset.krSelectCoin } }));
    target.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'start' });
    if (!coin) history.replaceState(null, '', anchor);
  });
  document.addEventListener('shopify:section:load', event => boot(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [element, dispose] of controllers) if (event.target.contains(element)) { dispose(); controllers.delete(element); }
  });
  document.addEventListener('shopify:block:select', event => {
    event.target.classList.add('kr-visible');
    event.target.scrollIntoView({ behavior: 'instant', block: 'center' });
  });
  reduced.addEventListener('change', () => {
    for (const dispose of controllers.values()) dispose();
    controllers.clear();
    document.querySelectorAll('.kr-reveal-ready').forEach(element => element.classList.remove('kr-reveal-ready'));
    document.querySelectorAll('[data-kr-tilt]').forEach(element => element.style.transform = '');
    boot();
  });
  document.addEventListener('visibilitychange', () => document.documentElement.classList.toggle('kr-document-paused', document.hidden));
  boot();
})();

/* KR CART START */
(() => {
  if (window.KoshirenCart) return;
  const bag = () => document.querySelector('[data-kr-cart]');
  const forms = () => [...document.querySelectorAll('[data-kr-order]')];
  const storageKey = 'kr-pending-add-v2';
  let busy = false, currentCart = null, pending = null, priorOverflow = '', lastTrigger;
  const initialized = new WeakSet();
  try { pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch {}
  const messages = () => { try { return JSON.parse(bag().querySelector('[data-kr-cart-messages]').textContent); } catch { return {}; } };
  const root = () => new URL(window.Shopify?.routes?.root || bag()?.dataset.root || '/', location.origin).pathname.replace(/\/?$/, '/');
  const money = (value, currency = 'USD') => {
    const locale = document.documentElement.lang || 'en';
    const amount = new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value / 100);
    return currency === 'USD' ? (locale.startsWith('zh') ? amount + ' 美元' : 'USD $' + amount) : new Intl.NumberFormat(locale, { style: 'currency', currency }).format(value / 100);
  };
  function syncForms() {
    for (const form of forms()) {
      form.setAttribute('aria-busy', String(busy));
      if (pending) form.dataset.krUncertain = 'true'; else delete form.dataset.krUncertain;
      form.querySelector('[data-kr-recover]').hidden = !pending;
      form.dispatchEvent(new CustomEvent('kr:cart-state'));
    }
  }
  function savePending(value) {
    pending = value;
    try { if (value) sessionStorage.setItem(storageKey, JSON.stringify(value)); else sessionStorage.removeItem(storageKey); } catch {}
    syncForms();
  }
  function setBusy(value) {
    busy = value;
    const dialog = bag();
    if (dialog) {
      dialog.setAttribute('aria-busy', String(value));
      dialog.querySelector('[data-kr-cart-progress]').hidden = !value;
      dialog.querySelectorAll('[data-kr-cart-delta],[data-kr-cart-remove],[data-kr-cart-retry],[name="checkout"]').forEach(button => {
        button.disabled = value || (button.name === 'checkout' && (!currentCart?.item_count || Boolean(pending))) || (button.dataset.krCartDelta === '1' && Number(button.closest('[data-key]')?.dataset.quantity) >= 99);
      });
    }
    syncForms();
  }
  function notice(text, failed = false) {
    const dialog = bag(); if (!dialog) return;
    const error = dialog.querySelector('[data-kr-cart-error]');
    const status = dialog.querySelector('[data-kr-cart-status]');
    error.hidden = !failed; status.hidden = failed || !text;
    (failed ? error : status).textContent = text || '';
    dialog.querySelector('[data-kr-cart-recovery]').hidden = !failed;
  }
  async function request(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), body ? 25000 : 12000);
    try {
      const response = await fetch(root() + path, { method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { body: JSON.stringify(body) } : {}), signal: controller.signal });
      let result;
      try { result = await response.json(); } catch { throw new Error('Invalid cart response'); }
      if (!response.ok) {
        const error = new Error(typeof result.description === 'string' ? result.description : messages().error);
        error.definite = response.status >= 400 && response.status < 500;
        throw error;
      }
      return result;
    } finally { clearTimeout(timer); }
  }
  async function readCart() {
    // Retrying a read is safe. Never automatically repeat an add or quantity mutation.
    for (let attempt = 0; attempt < 2; attempt++) {
      try {
        const cart = await request('cart.js');
        if (!Array.isArray(cart.items) || !Number.isFinite(cart.item_count)) throw new Error('Invalid cart data');
        return cart;
      } catch (error) { if (attempt) throw error; }
    }
  }
  function render(cart) {
    const dialog = bag(); if (!dialog) return;
    const fragment = document.createDocumentFragment();
    for (const item of cart.items) {
      const node = dialog.querySelector('[data-kr-cart-item]').content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key; node.dataset.quantity = String(item.quantity);
      node.querySelector('[data-kr-cart-title]').textContent = item.product_title || item.title;
      const variant = node.querySelector('[data-kr-cart-variant]');
      variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title || ''; variant.hidden = !variant.textContent;
      const img = node.querySelector('[data-kr-cart-image]'); img.alt = item.product_title || item.title;
      try { const url = new URL(item.image || item.featured_image?.url, location.origin); if (!item.image && !item.featured_image?.url || !/^https?:$/.test(url.protocol)) throw new Error(); url.searchParams.set('width', '180'); img.src = url.href; } catch { img.hidden = true; }
      node.querySelector('[data-kr-cart-quantity]').textContent = item.quantity;
      node.querySelector('[data-kr-cart-price]').textContent = money(item.final_line_price, cart.currency);
      fragment.append(node);
    }
    dialog.querySelector('[data-kr-cart-lines]').replaceChildren(fragment);
    dialog.querySelector('[data-kr-cart-empty]').hidden = cart.item_count > 0;
    dialog.querySelector('[data-kr-cart-footer]').hidden = !cart.item_count;
    dialog.querySelector('[data-kr-cart-total]').textContent = money(cart.total_price, cart.currency);
    document.querySelectorAll('[data-kr-cart-count]').forEach(node => { node.textContent = cart.item_count; node.hidden = !cart.item_count; });
    currentCart = cart;
    document.dispatchEvent(new CustomEvent('kr:cart-updated', { detail: { cart } }));
  }
  function show() {
    const dialog = bag(); if (!dialog) return false;
    if (!initialized.has(dialog)) {
      initialized.add(dialog);
      dialog.addEventListener('close', () => { document.body.style.overflow = priorOverflow; lastTrigger?.focus({ preventScroll: true }); });
      try { const initial = JSON.parse(dialog.querySelector('[data-kr-cart-initial]').textContent); if (Array.isArray(initial.items)) render(initial); } catch {}
    }
    if (!dialog.open) { lastTrigger = document.activeElement; priorOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal(); }
    return true;
  }
  const contains = (cart, operation) => cart.items.some(item => item.properties?._kr_request === operation.token);
  function remember(form, operation) { if (form) { form.dataset.krAddedToken = operation.token; form.dataset.krAddedSelection = operation.id + ':' + operation.quantity; } }
  function reconcile(cart, allowAbsent) {
    if (!pending) return;
    if (contains(cart, pending)) { for (const form of forms()) remember(form, pending); savePending(null); notice(messages().added); }
    else if (allowAbsent) { savePending(null); notice(messages().notAdded); }
    else notice(messages().uncertain, true);
  }
  async function refresh() {
    if (busy) return;
    show(); notice(messages().loading); setBusy(true);
    try { const cart = await readCart(); render(cart); notice(''); reconcile(cart, true); }
    catch { notice(pending ? messages().uncertain : messages().loadError, true); }
    finally { setBusy(false); }
  }
  function checkout(form) {
    const nativeForm = document.createElement('form');
    nativeForm.method = 'post'; nativeForm.action = form?.dataset.cartUrl || bag().querySelector('[data-kr-cart-footer]').action;
    const input = document.createElement('input'); input.type = 'hidden'; input.name = 'checkout'; input.value = 'checkout';
    nativeForm.append(input); document.body.append(nativeForm); nativeForm.submit();
  }
  async function add(form, intent) {
    if (busy) return;
    if (pending) { await refresh(); return; }
    const option = form.querySelector('[data-kr-product]').selectedOptions[0];
    const quantity = Number(form.elements.quantity.value);
    if (!option || option.dataset.available !== 'true' || !Number.isSafeInteger(Number(option.value)) || !Number.isInteger(quantity) || quantity < 1 || quantity > 99 || !form.reportValidity()) return;
    const operation = { token: crypto.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2), id: Number(option.value), quantity };
    show(); notice(messages().loading); setBusy(true);
    try {
      // Buy after adding the same selection should checkout that line, not add it twice.
      if (intent === 'checkout' && form.dataset.krAddedSelection === operation.id + ':' + quantity) {
        const cart = await readCart(); render(cart);
        if (cart.items.some(item => item.properties?._kr_request === form.dataset.krAddedToken && item.quantity >= quantity)) { checkout(form); return; }
      }
      savePending(operation);
      let acknowledged = false, failure;
      try { await request('cart/add.js', { items: [{ id: operation.id, quantity, properties: { _kr_request: operation.token } }] }); acknowledged = true; }
      catch (error) { failure = error; }
      let cart;
      try { cart = await readCart(); render(cart); } catch {}
      if (acknowledged || cart && contains(cart, operation)) {
        remember(form, operation);
        if (cart) savePending(null);
        if (intent === 'checkout') { savePending(null); checkout(form); return; }
        notice(cart ? messages().added : messages().addedRefresh, !cart);
      } else if (failure?.definite) { savePending(null); notice(failure.message || messages().error, true); }
      else notice(messages().uncertain, true);
    } catch { notice(messages().loadError, true); }
    finally { setBusy(false); }
  }
  window.KoshirenCart = { add, refresh, get busy() { return busy; } };
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-kr-cart-open],[data-kr-recover],[data-kr-cart-retry]') && bag()) { event.preventDefault(); await refresh(); return; }
    if (event.target.closest('[data-kr-cart-close]')) { bag()?.close(); return; }
    const addButton = event.target.closest('[data-kr-add-order]');
    if (addButton) { event.preventDefault(); await add(addButton.closest('[data-kr-order]'), 'cart'); return; }
    const change = event.target.closest('[data-kr-cart-delta],[data-kr-cart-remove]');
    if (!change || busy || pending) return;
    const line = change.closest('[data-key]');
    const quantity = change.hasAttribute('data-kr-cart-remove') ? 0 : Math.max(0, Math.min(99, Number(line.dataset.quantity) + Number(change.dataset.krCartDelta)));
    setBusy(true); notice(messages().loading);
    try { render(await request('cart/change.js', { id: line.dataset.key, quantity })); notice(''); }
    catch (error) {
      try { const cart = await readCart(); render(cart); const item = cart.items.find(item => item.key === line.dataset.key); if ((item?.quantity || 0) === quantity) notice(''); else notice(error.definite ? error.message : messages().updateError, true); }
      catch { notice(messages().loadError, true); }
    } finally { setBusy(false); }
  });
  document.addEventListener('submit', event => {
    if (!event.target.matches('[data-kr-cart-footer]')) return;
    if (busy || pending || !currentCart?.item_count) { event.preventDefault(); return; }
    // Keep the clicked checkout value in the native POST before disabling controls.
    event.preventDefault(); setBusy(true); checkout();
  });
  window.addEventListener('pageshow', () => { setBusy(false); if (bag()?.open) refresh(); });
  document.addEventListener('shopify:section:load', syncForms);
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-kr-cart]')?.open) document.body.style.overflow = priorOverflow; });
  syncForms();
})();
